export const fetchImgAsBase64 = Logger.logAsync(async (src) => {
  const response = await fetch(src);
  const blob = await response.blob();
  const reader = new FileReader();

  return new Promise((res, rej) => {
    reader.onloadend = function onloadend() {
      res(reader.result);
    };

    reader.onerror = function onerror(event) {
      rej(event);
    };

    reader.readAsDataURL(blob);
  });
});

const base64regex = /data:image\/([a-zA-Z]*);base64,([^"]*)/;

export function isBase64(string) {
  return base64regex.test(string);
}

export const noCache = () => ({ cache: false });
